import React from 'react'

const RiparideSmallLogo = (props) => (
  <svg viewBox="0 0 27 22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      d="M25.8 18.9c-2 0-3.9-1.2-4.9-2v-2.1c1 .8 2.3 1.5 3.7 1.8l1.2.2.5-2.4-1.2-.2c-1.8-.4-3.4-1.8-4.2-2.6V9.7c.7.6 1.6 1.1 2.6 1.4l1.2.4.7-2.4-1.2-.4c-1.3-.4-2.5-1.6-3.3-2.3V4.6c.3.2.6.4.9.7l1 .7 1.3-2.1-1-.7c-.9-.6-1.6-1.3-2.1-1.8-.3-.2-.4-.4-.6-.5-.4-.3-1-.3-1.5 0-.2.1-.4.3-.6.6-.5.5-1.2 1.2-2.1 1.8l-1 .7 1.3 2 1-.7c.3-.2.6-.4.9-.7v1.7l-.2.2c-.7.7-1.8 1.8-3.1 2.2l-1.2.4.7 2.3 1.2-.4c1-.3 1.9-.9 2.6-1.4v1.8l-.2.2c-.8.8-2.4 2.2-4.1 2.6l-1.1.3.5 2.4 1.2-.3c1.4-.3 2.7-1.1 3.7-1.9v2c-.9.7-2.8 2.1-4.9 2.1-2.3 0-4.5-1.7-5.3-2.3-.1-.1-.1-.1-.2-.1-.4-.3-1-.3-1.5 0-.1 0-.1.1-.2.2-.8.6-2.9 2.2-5.1 2.3H0v2.5h1.2c2.6 0 4.8-1.5 6-2.3 1.2.9 3.5 2.3 6.2 2.3 2.6 0 4.8-1.5 6-2.3 1.2.9 3.5 2.3 6.2 2.3H27v-2.5z"
    />
  </svg>
)

export default RiparideSmallLogo
